var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1L0 23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24H23C23.2652 24 23.5196 23.8946 23.7071 23.7071C23.8946 23.5196 24 23.2652 24 23V1C24 0.734784 23.8946 0.48043 23.7071 0.292893C23.5196 0.105357 23.2652 0 23 0V0ZM19.938 5.686L18.651 6.92C18.5966 6.96147 18.5545 7.017 18.5293 7.08061C18.5041 7.14423 18.4967 7.21351 18.508 7.281V16.349C18.4967 16.4165 18.5041 16.4858 18.5293 16.5494C18.5545 16.613 18.5966 16.6685 18.651 16.71L19.908 17.944V18.215H13.586V17.944L14.886 16.68C15.014 16.552 15.014 16.514 15.014 16.319V8.99L11.393 18.19H10.904L6.691 8.99V15.153C6.67366 15.2808 6.68562 15.4109 6.72599 15.5334C6.76636 15.6559 6.83407 15.7676 6.924 15.86L8.618 17.914V18.185H3.818V17.914L5.509 15.86C5.5982 15.7675 5.6644 15.6553 5.70227 15.5325C5.74014 15.4097 5.74861 15.2797 5.727 15.153V8.027C5.73727 7.92963 5.72452 7.83121 5.68978 7.73967C5.65504 7.64813 5.59929 7.56604 5.527 7.5L4.019 5.686V5.415H8.693L12.306 13.339L15.482 5.415H19.938V5.686Z",
    fill: "url(#paint0_linear_52_915)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_915",
    x1: 3.30821e-7,
    y1: 4.59961,
    x2: 24.0153,
    y2: 4.61857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3416B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45F48"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedActive);
export default __webpack_public_path__ + "static/media/med_active.c7ea52b5c5e523917e5f22c7f5fd81f1.svg";
export { ForwardRef as ReactComponent };